module.exports = __webpack_public_path__ + "img/cursor.530c7f04.png";